import { render, staticRenderFns } from "./LoginToken.vue?vue&type=template&id=91fdcb52&scoped=true&"
import script from "./LoginToken.vue?vue&type=script&lang=js&"
export * from "./LoginToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fdcb52",
  null
  
)

export default component.exports